import { defineComponent as o, provide as l, toRef as s, createElementBlock as n, openBlock as r, createElementVNode as i, renderSlot as a } from "vue";
import { sizeInjectionKey as c } from "./HorizontalSeriesBlock.constant.js";
const d = { class: "overflow-x-auto md:mx-auto md:w-full" }, p = { class: "bg-static-default-mid text-static-default-hi rounded-lg inline-flex list-none justify-start gap-32 px-24 py-16 md:w-full" }, x = /* @__PURE__ */ o({
  name: "RevHorizontalSeriesBlock",
  __name: "HorizontalSeriesBlock",
  props: {
    size: { default: "large" }
  },
  setup(e) {
    return l(c, s(e, "size")), (t, m) => (r(), n("div", d, [
      i("ul", p, [
        a(t.$slots, "default")
      ])
    ]));
  }
});
export {
  x as default
};
